export default {
		html: 'pointOfInterest.KEY_HTML',
		script: 'pointOfInterest.KEY_SCRIPT',
		url: 'pointOfInterest.KEY_URL',
		pattern: 'pointOfInterest.KEY_PATTERN',
		purchaseConfirmation: 'pointOfInterest.KEY_PURCHASE'
	};
